import React from 'react';
import { string } from 'prop-types';
import './styles.scss';

const ChannelPicker = ({ img }) => {
  return (
    <div className="channel-card d-flex justify-content-center">
      <img className="channel-card__Image" src={ img } alt="Logo del canal" />
    </div>
  )
}

ChannelPicker.propTypes = {
  img: string.isRequired
};

export default ChannelPicker;
